import React from "react";
import { useTranslation } from 'react-i18next';

export default function ExamSuspendedOverlay() {
    const { t } = useTranslation();

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.97)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '16px',
                padding: '52px 48px',
                maxWidth: '540px',
                width: '90%',
                textAlign: 'center',
                boxShadow: '0 16px 48px rgba(0,0,0,0.5)',
            }}>
                <div style={{ fontSize: '60px', marginBottom: '20px', lineHeight: 1 }}>⏸</div>
                <h2 style={{ color: '#222', marginBottom: '16px', fontWeight: 700, fontSize: '28px' }}>
                    {t('exam_suspended_title')}
                </h2>
                <p style={{ color: '#555', fontSize: '17px', lineHeight: '1.65', marginBottom: '32px', margin: '0 0 32px' }}>
                    {t('exam_suspended_text')}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', color: '#888', fontSize: '14px' }}>
                    <div className="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true" />
                    <span>{t('exam_suspended_waiting')}</span>
                </div>
            </div>
        </div>
    );
}
